import { useEffect } from 'react';

import { useDealContext } from '@/lib/contexts/deal.context';

export function useDocumentTitle(titlePrefix = ''): void {
  const { deal } = useDealContext();

  useEffect(() => {
    const name = deal.hubspotInfos.dealName
      ? `${deal.hubspotInfos.dealName} | Smart Offers`
      : 'Smart Offers';
    document.title = `${titlePrefix}${name}`;
  }, [titlePrefix, deal]);
}
